import React from 'react'

import './sent.scss'

export default (props)=>
    <svg {...props} id="sent-icon" width="27" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 7.09232L7.26577 13.5L19 1.5" stroke="#7DDE8B" stroke-width="2"/>
    </svg>
